module.exports = __webpack_public_path__ + "static/media/REVIEWS-SNOWFLAKE_SNOWFLAKE.a2584ddf.svg";